(function() {
    'use strict';

    angular
        .module('consinfApp')
        .controller('VideoInformativoDialogController', VideoInformativoDialogController);

    VideoInformativoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'VideoInformativo'];

    function VideoInformativoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, VideoInformativo) {
        var vm = this;

        vm.videoInformativo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.videoInformativo.id !== null) {
                VideoInformativo.update(vm.videoInformativo, onSaveSuccess, onSaveError);
            } else {
                VideoInformativo.save(vm.videoInformativo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('consinfApp:videoInformativoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.validoDa = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
